var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"feature-block"},[_c('article',{staticClass:"feature-image-container"},[_c('FeatureCard',{attrs:{"idx":_vm.idx,"title":_vm.title,"description":_vm.description}}),_vm._v(" "),_c('FeatureImage',{attrs:{"idx":_vm.idx,"img":_vm.img}})],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-65fe34ba","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/LP/molecules/FeatureBlock.vue
// module id = null
// module chunks = 